import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Components

import CommonHeader from '@components/ssap/headers/CommonHeader';
import ButtonContainer from './ButtonContainer';
import { configs } from '@constants/configs/configs';

//constants
import { PAGES } from '@constants/ssap/flows/pagesTypes';
import { IEX_STATE_CODES } from '@constants/configs/states';
import { useExchangeAndProgramNames } from '@reducers/appReducer';

const BackToApplication = ({ backUrl, backLinkText }) => {
    return (
        <span className="usa-width-one-whole back-to-dashboard">
            <Link className="usa-width-one-whole border-link" to={backUrl || configs.routes.INDPORTAL}>
                <FontAwesomeIcon icon="caret-left" size="1x" className="icon-link" />
                <FormattedMessage id={backLinkText || 'dashboard.back.link'} />
            </Link>
        </span>
    );
};


const CommonHeaderContainer = props => {

    const {
        stateCode,
        adjustedFlow,
        linkFrom,
        page,
        ssapLaunchData: {
            consumer,
            backUrl,
            backLinkText
        }
    } = props;

    const { exchangeMedicaidSlashChip } = useExchangeAndProgramNames();

    const getPropsForHeader = () => {

        const pageName = adjustedFlow[page].pageName;

        const isPrintPage = pageName === PAGES.FINAL_APPLICATION_REVIEW_PAGE;
        const isFromMyApp = linkFrom['MyApplications'];
        const isFromCapApp = consumer === 'CAP';

        let updatedProps = {
            headerText: (isPrintPage && (isFromMyApp || isFromCapApp))
                ? <BackToApplication backUrl={backUrl} backLinkText={backLinkText} />
                : <FormattedMessage id={adjustedFlow[page].page.navBarText} values={{ exchangeMedicaidSlashChip }} />,
            pageName
        };

        const extraButton = adjustedFlow.length > 0 ?  adjustedFlow[page].page.extraButtons : '';

        if(extraButton) {
            updatedProps = {
                ...updatedProps,
                additionalElement: (
                    <ButtonContainer
                        type={Object.keys(extraButton)[0]}
                        args={[]}
                    />
                ),
                additionalElementClassName: 'mobile:grid-col-12 tablet:grid-col-auto float-right header-btn'
            };
        }



        return updatedProps;
    };
    const isMN = stateCode === IEX_STATE_CODES.MN;
    return (
        <div
            className={`${isMN ? 'grid-container fade-in main-section__content--title header-without-sideNav'  : 'grid-container fade-in main-section__content--title'}`}
        >
            <CommonHeader
                { ...getPropsForHeader() }
            />
        </div>
    );

};

const mapStateToProps = state => ({
    messages: state.common.messages,
    stateCode: state.common.environment.stateCode,
    linkFrom: state.ssap.linkFrom,
    ssapLaunchData: state.ssap.launchData,
    adjustedFlow: state.ssap.adjustedFlow,
    flow: state.ssap.flow,
    key: `header_key_${state.ssap.page}`,
    page: state.ssap.page
});

export default connect(mapStateToProps)(CommonHeaderContainer);
